import styled from '@emotion/styled'
import { FormControlLabel, Box } from '@mui/material'

export const FormGroupLabelWrap = styled(FormControlLabel)(`
  & .MuiTypography-root {
    font-size: 12px;
    // white-space: nowrap;
  }

  &.themeV2{
    margin-left: 0px;
    margin-right: 0px;
    display: flex;

    &.form-check-label-p {
      gap : 8px;
    }

    & .MuiTypography-root{
      font-size: 14px;
      font-weight: 400; // 300;
    }
    & span{
      padding: 0;
    }
    & input{
      height: 20px;
      width: 20px;
    }

    & .Mui-disabled {
      .MuiBox-root {
        border : 1px solid #efefef;
        background : #F6F6F5;

        path {
         fill : #ADADAC;
        }
      }
    } 
  }

  &.small input, &.small .MuiCheckbox-root, &.small .MuiBox-root {
    height: 16px !important;
    width: 16px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  & .MuiCheckbox-root {
    svg {
      height: 1em;
      width : 1em;
    }

    &.large svg {
      font-size: 2.1875rem;
    }
    &.medium svg {
      font-size: 1.5rem;
    }
    &.small svg {
      font-size: 1.25rem;
    }
  }

  &.vOutlined svg path {
    fill : none;
    stroke : currentColor;
  }

  &.vContained svg path {
    fill : currentColor;
    stroke : white;
  }
  &.vContained .Mui-checked svg rect {
    fill : currentColor;
  }
`)

export const CheckboxIconTheme2 = styled(Box)(`
  width: 20px;
  height: 20px;
  border: 1px solid #1A73E8;
  border-radius: 4px;
`)

export const CheckboxCheckedIconTheme2 = styled(Box)(`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #1A73E8;
  display: flex;
  align-items: center;
  justify-content: center;
`)
